<template>
    <TheHeader bgClass="header-bg-color" fontClass="fontColor2"/>

    <ThePageSubTitle titleMsg="News & Event" msg="News & Events"/>
    <br/>
    <br/>

    <template v-if="display">
        <div class="main-news-wrapper">
            <div  class="big-content-wrapper">
                <img alt="LIFT EXPERTS" src="../assets/images/news/news-cover-001.jpg"/>
                <div class="info-wrapper montserrat-500 fontColor1">
                    FEATURES
                    <br/>
                    <span class="poppins-normal">Happy Chinese New Year</span>
                    <br/>
                    Wishing all of you a Happy, Healthy and Prosperous Chinese New Year ! 恭贺大家在新的一年里，身体健康，财源广进，家庭幸福!
                    <br/>
                    <br/>
                    <div @click="openModal('content-1')" class="btn-read-more fontColor2">Read More</div>
                </div>
            </div>
    
            <div class="big-content-wrapper">
                <img alt="LIFT EXPERTS" src="../assets/images/news/news-cover-002.jpg"/>
                <div class="info-wrapper montserrat-500 fontColor1">
                    FEATURES
                    <br/>
                    Preliminary discussion with the Special Officer to the Finance Minister on the topic of import duty of brand new mobile 
                    cranes took place on 06-12-2019...
                    <br/>
                    <br/>
                    <div @click="openModal('content-2')" class="btn-read-more fontColor2">Read More</div>
                </div>
            </div>
        </div>
    
        <div class="news-wrapper-two">
            <img alt="LIFT EXPERTS" src="../assets/images/news/news-cover-003.jpg"/>
            <div class="info-wrapper-two montserrat-500 fontColor1">
                FEATURES
                <br/>
                Mediation Talk at MMCOA / 马来西亚吊秤车同业公会举办【如何进行调解】讲座会
                <br/>
                <br/>
                MMCOA (1987) organized a Mediation Talk to enable members to find out better alternatives to resolve disputes. 马来西亚吊秤车同业公会（１９８７）举办【如何进行调解】讲座会，让会员清楚解决纠纷的各种方式。
                <br/>
                <br/>
                <div @click="openModal('content-3')" class="btn-read-more fontColor2">Read More</div>
            </div>
        </div>
    </template>

    <template v-if="display">
        <ShareModal
            v-model:visible="showModal"
            @ok="onConfirm"
            @cancel="onCancel"
            >
            <div v-if="triggerKey === 'content-1'" class="montserrat-500"> 
                <h3>Happy Chinese New Year</h3>
                <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 22/01/2020</p>
                <p>
                    Wishing all of you a Happy, Healthy and Prosperous Chinese New Year !
                    <br/>
                    恭贺大家在新的一年里，身体健康，财源广进，家庭幸福!
                </p>
                <a-image-preview-group>
                    <a-image :width="200" :src="require('@/assets/images/news/news-001.jpg')" />
                </a-image-preview-group>
            </div>
            <div v-else-if="triggerKey === 'content-2'" class="montserrat-500">
                <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 07/12/2019</p>
                <br/>
                <a-image-preview-group>
                    <a-image
                        v-for="(img, index) in news2Images"
                        :key="index"
                        :width="100"
                        :src="require(`@/assets/images/news/news-002/${img}`)"
                        :alt="`Press Conference Image ${index + 1}`"
                    />
                </a-image-preview-group>
                <br/>
                <p> 
                    Preliminary discussion with the Special Officer to the Finance Minister on the topic of 
                    import duty of brand new mobile cranes took place on 06-12-2019. Exchanging views and touching 
                    on expectations and constraints of both sides.
                    <br/>
                    <br/>
                    Good start and in the right direction for the future development and sustainability of the 
                    lifting industry. However, there are still have a lot of things to be coordinated.
                    <br/>
                    <br/>
                    2019年12月6日，和财政部长的特别助理针对入口崭新吊车的税务进行了的初步讨论。大家互相交换意见以探讨双方的期望与限制。
                    <br/>
                    <br/> 
                    对于吊秤行业长期的发展，这是一个非常好的新起点。然而，还有很多事项需要进行协调的。
                </p>
            </div>
            <div v-else-if="triggerKey === 'content-3'" class="montserrat-500">
                <h3>Mediation Talk at MMCOA / 马来西亚吊秤车同业公会举办【如何进行调解】讲座会</h3>
                <p>Published by <span class="montserrat-600">Editor MMCOA</span> on 04/12/2019</p>
                <br/>
                <a-image-preview-group>
                    <a-image
                        v-for="(img, index) in news3Images"
                        :key="index"
                        :width="100"
                        :src="require(`@/assets/images/news/news-003/${img}`)"
                        :alt="`Press Conference Image ${index + 1}`"
                    />
                </a-image-preview-group>
                <br/>
                <p>MMCOA (1987) organized a Mediation Talk</p>
            </div>
        </ShareModal>
    </template>

    <br/>
    <br/>

    <TheSubNews/>

    <br/>
    <br/>
    <TheSponsor bgClass="header-bg-color"/>

    <!-- Copyright -->
    <TheCopyRight/>
    <div>

    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import ThePageSubTitle from '@/components/ThePageSubTitle.vue'
import TheSponsor from '@/components/TheSponsor.vue'
import TheCopyRight from '@/components/TheCopyRight.vue'
import ShareModal from '@/components/ShareModal.vue'
import TheSubNews from '@/components/TheSubNews.vue'


export default {
  name: 'News & Event',
  components: {
    TheHeader,
    ThePageSubTitle,
    TheSponsor,
    TheCopyRight,
    ShareModal,
    TheSubNews
  },
    data() {
        return {
            display: false,
            showModal: false,
            triggerKey: '',
            news2Images: Array.from({ length: 5 }, (_, i) => `news-002-${i + 1}.jpg`),
            news3Images: Array.from({ length: 6 }, (_, i) => `news-003-${i + 1}.jpg`),
        }
    },
    methods: {
        openModal(key) {
            console.log('Confirmed')
            this.triggerKey = key;
            this.showModal = true;
        },
        handleOk() {
            console.log('OK clicked for:', this.triggerKey)
            this.showModal = false
        }
    },
    computed: {}

}

</script>

<style scoped>
.main-news-wrapper {text-align: center;}
.big-content-wrapper {position: relative; width: 80%; margin: 0 auto;}
.news-wrapper-two {width: 80%; margin: 0 auto; text-align: center; position: relative;}

.big-content-wrapper img, .news-wrapper-two img{width: 100%;}
.info-wrapper {
    font-size: 9px; 
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    line-height: 1.2;
}

.info-wrapper-two{
    font-size: 8px; 
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    line-height: 1.2;
}

.btn-read-more {
    border-radius: 7px;
    background-color: #fff200;
    width: 100px;
    margin: 0 auto;
    font-size: 8px;
    padding: 8px 0;
    cursor: pointer;
}
:deep(.ant-image ) {
    margin-right: 10px;
    margin-bottom: 10px;
}

@media screen and (min-width: 768px) {
    .main-news-wrapper {
        display: flex;
        flex-wrap: wrap;
        width: 80%;
        margin: 0 auto;
    }
    .news-wrapper-two {width: 78%;}
    .big-content-wrapper {width: 47%;}
    .info-wrapper, .info-wrapper-two {
        font-size: 10px; 
        line-height: 1.1;
    }
}

@media screen and (min-width: 1024px) {
    .info-wrapper, .info-wrapper-two {
        font-size: 12px; 
        width: 80%;
        line-height: 1.6;
    }
    .btn-read-more {
        font-size: 10px;
        padding: 8px 0;
    }
}

</style>